import cn from 'classnames';
import * as React from 'react';
import { animated as a, useSpring } from 'react-spring';

import styles from './FlipCard.module.scss';

interface IProps {
  flipped: boolean;
  front: React.ReactNode;
  back: React.ReactNode;
  className?: string;
}

const FlipCard: React.FC<IProps> = ({ flipped, front, back }) => {
  const { transform } = useSpring({
    opacity: flipped ? 1 : 0,
    transform: `perspective(600px) rotateX(${flipped ? 180 : 0}deg)`,
    config: { mass: 5, tension: 500, friction: 80 },
  });

  return (
    <div className={styles.container}>
      <a.div className={styles.inner} style={{ transform }}>
        <div className={cn(styles.face, styles.front)}>{front}</div>
        <div className={cn(styles.face, styles.back)}>{back}</div>
      </a.div>
    </div>
  );
};

export default FlipCard;
